<template>
    <section class="vizy-blocks-content-builder-image-slider vizy-blocks__block--full-bleed">
        <h1
            v-if="title"
            class="vizy-blocks-content-builder-image-slider__title"
        >
            {{ title }}
        </h1>
        <p
            v-if="description"
            class="vizy-blocks-content-builder-image-slider__description"
        >
            {{ description }}
        </p>
        <template v-if="pending">
            <Skeletor
                v-for="i in [1,2,3]"
                :key="i"
                class="vizy-blocks-content-builder-image-slider__image"
                :shimmer="false"
            />
        </template>
        <BaseSlider
            v-if="images?.length"
            :items="images || []"
            :aspect-ratio="aspectRatio"
            :controls-enabled="true"
            :pagination-type="'scroll'"
        >
            <template
                v-for="(item, index) in images"
                #[`slide-${index}`]
                :key="`slide-${index}`"
            >
                <div
                    class="vizy-blocks-content-builder-image-slider__image"
                    :class="{
                        'vizy-blocks-content-builder-image-slider__image--landscape': getPortraitImage(item?.image?.[0]) === false
                    }"
                >
                    <BaseImage
                        v-if="item?.image?.[0]?.url"
                        :image="item.image[0]"
                        :draggable="false"
                        :alt="item?.image?.[0]?.alt || item?.image?.[0]?.title"
                        sizes="(min-width: 1024px) 606px, 328px"
                    />

                    <p
                        v-if="images.some(i => i.caption)"
                        class="vizy-blocks-content-builder-image-slider__caption"
                    >
                        {{ item.caption }}
                    </p>
                </div>
            </template>
        </BaseSlider>
    </section>
</template>

<script setup>
import { Skeletor } from 'vue-skeletor';

defineProps({
    pending: {
        type: Boolean,
        default: false
    },
    images: {
        type: Array,
        required: true,
        default: () => []
    },
    title: {
        type: String,
        required: false,
        default: undefined
    },
    description: {
        type: String,
        required: false,
        default: undefined
    },
    aspectRatio: {
        type: String,
        required: false,
        default: 'horizontal'
    }
});

const getPortraitImage = (image) => {
    if (!image) {
        return false;
    }

    if (image?.width && image?.height) {
        return image.width < image.height;
    }
    return false;
};
</script>

<style lang="less">

.vizy-blocks-content-builder-image-slider{
    //grid-template-rows : auto;
    .base-grid(var(--maxPageWidth), false);

    .vizy-blocks-content-builder-image-slider__title {
        grid-column: left-gutter/third;
    }

    .vizy-blocks-content-builder-image-slider__description {
        grid-column: first/right-side-gutter;

        @media @q-lg-min {
            grid-column: left-gutter/third;
        }
    }

    .base-slider {
        grid-column: 1/-1;
    }
}

.vizy-blocks__block[data-type='imageSlider'],
.vizy-blocks__block--full-bleed {
    grid-column: 1/-1;

    @media screen and (min-width: 90rem) {
        margin-inline: calc((100vw - var(--grid-maxWidth-page) - var(--scrollbar-width)) / 2 * -1);
    }
}

.vizy-blocks-content-builder-image-slider__title {
    .typography-h2();
    text-align: center;

    max-width: 15.18rem;
    margin: 0 auto var(--spacing-sm);
}

.vizy-blocks-content-builder-image-slider__description {
    .typography-text();
    margin-bottom: var(--spacing-xl);
    text-align: center;
}

.vizy-blocks-content-builder-image-slider__image {
    display: flex;
    flex-direction: column;

    &,
    figure,
    figure picture {
        height: calc(100% - var(--spacing-xs));
    }
}

.vizy-blocks-content-builder-image-slider__image--landscape {
    min-width: 37.5rem;
}

.vizy-blocks-content-builder-image-slider__caption {
    .typography-text-sm();
    margin-top: var(--spacing-xs);
    max-width: 17.125rem; // figma
    height: 3.956rem;
}
</style>
